import { trigger, transition, state, style, animate } from '@angular/animations';

export const MAP_ANIMATIONS = [
    trigger('mapTitle', [
        state('expanded', style({
            fontSize: '28px'
        })),
        transition('shrunk <=> expanded', animate('500ms'))
    ])
];
